import React, { FC } from 'react';
import { EChartsOption } from 'echarts';
import ReactECharts from 'echarts-for-react';

export interface EChartsContainerProps {
  option: EChartsOption;
  className?: string;
  style?: React.CSSProperties;
  error?: string | Error | null;
  loading?: boolean;
  onEvents?: Record<string, (params: unknown) => void>;
  onChartReady?: (chart?: unknown) => void;
}

const defaultChartStyle = { height: '400px', width: '100%' };

export const EChartsContainer: FC<EChartsContainerProps> = ({
  option,
  className,
  style,
  error = null,
  loading = false,
  onEvents,
  onChartReady,
}) => {
  if (error) {
    return (
      <div
        className={className}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px',
          color: '#d32f2f',
          ...style,
        }}>
        <div>
          <strong>Error loading chart:</strong> {error instanceof Error ? error.message : String(error)}
        </div>
      </div>
    );
  }

  return (
    <ReactECharts
      option={option}
      style={style ?? defaultChartStyle}
      className={className}
      onEvents={onEvents}
      showLoading={loading}
      onChartReady={onChartReady}
    />
  );
};
